function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
import { useMemo } from "react";
function carinaRadioBase(param) {
    var animation = param.animation, font = param.font, spacing = param.spacing, start = param.start;
    var _obj;
    return _obj = {
        borderRadius: '50%',
        boxSizing: 'border-box',
        content: '""',
        display: 'block',
        position: 'absolute',
        top: 0,
        height: spacing[5],
        width: spacing[5],
        fontSize: font.base.size.m,
        cursor: 'pointer'
    }, _defineProperty(_obj, start.padding, spacing[3]), _defineProperty(_obj, start.direction, "-".concat(spacing[5])), _defineProperty(_obj, "transitionProperty", 'box-shadow'), _defineProperty(_obj, "transitionDuration", animation.duration[100]), _defineProperty(_obj, "transitionTimingFunction", animation.productive.easeInOut.easing), _obj;
}
var buildStyle = function(theme, direction) {
    var animation = theme.animation, backgroundColor = theme.backgroundColor, borderColor = theme.borderColor, font = theme.font, size = theme.size, spacing = theme.spacing;
    var end = direction.end, start = direction.start;
    var _obj, _obj1, _obj2;
    return {
        'rb-div': {
            base: {
                position: 'relative',
                padding: "".concat(spacing[3], " 0"),
                outline: 'none',
                display: 'inherit'
            },
            inline: {
                display: 'inline-block'
            }
        },
        'rb-label': {
            base: (_obj = {
                display: 'inline-block',
                fontSize: font.base.size.s
            }, _defineProperty(_obj, start.margin, spacing[5]), _defineProperty(_obj, start.padding, spacing[3]), _defineProperty(_obj, "position", 'relative'), _defineProperty(_obj, '&::before', _objectSpread({}, carinaRadioBase({
                animation: animation,
                font: font,
                spacing: spacing,
                start: start
            }), {
                backgroundColor: backgroundColor.base,
                color: font.color.base,
                border: "".concat(size.border.base, "px solid ").concat(borderColor.base)
            })), _obj),
            error: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    border: "".concat(size.border.base, "px solid ").concat(backgroundColor.danger.fill.base)
                })
            },
            disabled: {
                color: font.color.disabled,
                cursor: 'not-allowed',
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    backgroundColor: backgroundColor.surface,
                    color: font.color.disabled,
                    cursor: 'not-allowed'
                })
            },
            disabledChecked: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    border: "".concat(size.border.base, "px solid ").concat(borderColor.disabled),
                    background: borderColor.disabled
                })
            },
            inline: _defineProperty({}, end.padding, '1rem'),
            checked: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    background: borderColor.interactive.base,
                    border: "".concat(size.border.base, "px solid ").concat(borderColor.interactive.base)
                }),
                '&::after': (_obj1 = {
                    borderRadius: '50%',
                    boxSizing: 'border-box',
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    cursor: 'pointer',
                    fontSize: spacing[5],
                    background: backgroundColor.base
                }, _defineProperty(_obj1, start.direction, '-11px'), _defineProperty(_obj1, "top", '5px'), _defineProperty(_obj1, "height", '0.375rem'), _defineProperty(_obj1, "width", '0.375rem'), _obj1)
            },
            checkedError: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    background: borderColor.danger.base,
                    border: "".concat(size.border.base, "px solid ").concat(borderColor.danger.base)
                })
            },
            focused: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.interactive.focus)
                })
            },
            focusedChecked: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.interactive.focus),
                    background: borderColor.interactive.base,
                    border: "".concat(size.border.base, "px solid ").concat(borderColor.interactive.base)
                }),
                '&::after': (_obj2 = {
                    borderRadius: '50%',
                    boxSizing: 'border-box',
                    content: '""',
                    display: 'block',
                    position: 'absolute',
                    cursor: 'pointer',
                    fontSize: spacing[5],
                    background: backgroundColor.base
                }, _defineProperty(_obj2, start.direction, '-11px'), _defineProperty(_obj2, "top", '5px'), _defineProperty(_obj2, "height", '0.375rem'), _defineProperty(_obj2, "width", '0.375rem'), _obj2)
            },
            focusedCheckedError: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    background: borderColor.danger.base,
                    border: "".concat(size.border.base, "px solid ").concat(borderColor.danger.base),
                    boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.danger.focus)
                })
            },
            focusedError: {
                '&::before': _objectSpread({}, carinaRadioBase({
                    animation: animation,
                    font: font,
                    spacing: spacing,
                    start: start
                }), {
                    boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.danger.focus)
                })
            }
        },
        'rb-input': {
            base: {
                position: 'absolute',
                left: '-9999px'
            }
        }
    };
};
export default function useStyle(param) {
    var hasError = param.hasError, isChecked = param.isChecked, isFocused = param.isFocused, disabled = param.disabled, inline = param.inline, isRtl = param.isRtl;
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    return useMemo(function() {
        return {
            div: _objectSpread({}, builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-div'].base, inline && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-div'].inline)),
            label: _objectSpread({}, builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].base, isChecked && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].checked), isFocused && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].focused), isFocused && isChecked && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].focusedChecked), inline && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].inline), hasError && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].error), hasError && isChecked && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].checkedError), hasError && isFocused && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].focusedError), hasError && isFocused && isChecked && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].focusedCheckedError), disabled && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].disabled), disabled && isChecked && (builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-label'].disabledChecked)),
            input: _objectSpread({}, builtStyle === null || builtStyle === void 0 ? void 0 : builtStyle['rb-input'].base)
        };
    }, [
        builtStyle,
        disabled,
        hasError,
        inline,
        isChecked,
        isFocused
    ]);
};
